import { DRIVE_MODE, ENABLED_DRIVE_MODES } from '@constants/aiController';
import { TOGGLE_DRIVE_MODE, SET_ENABLED_DRIVE_MODES } from '../actionTypes';

const initialState = {
	driveMode: DRIVE_MODE.human,
	enabledDriveModes: ENABLED_DRIVE_MODES.both
};

export const aiController = (state = initialState, action) => {
	switch (action.type) {
		case TOGGLE_DRIVE_MODE:
			return {
				...state,
				driveMode: state.driveMode === DRIVE_MODE.human ? DRIVE_MODE.ai : DRIVE_MODE.human
			};
		case SET_ENABLED_DRIVE_MODES:
			const newEnabledMode = action.payload || ENABLED_DRIVE_MODES.both;
			// If AI-only mode, force drive mode to AI
			const newDriveMode = newEnabledMode === DRIVE_MODE.ai ? DRIVE_MODE.ai : state.driveMode;
			return {
				...state,
				enabledDriveModes: newEnabledMode,
				driveMode: newDriveMode
			};
		default:
			return state;
	}
};
